import React, {Component} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {getUserDetails} from "../RequestManager";
import {socket} from "../components/Socket";
import {
    Accordion,
    Divider,
    Grid,
    Group,
    Loader, Pagination,
    Paper,
    Button, Tabs,
    Text, SegmentedControl, Select, Modal
} from "@mantine/core";
import BookView from "../components/BookView";
import CustomHeader from "../components/CustomHeader";
import {Colors} from "../Constants/Colors";

class PlanDetails extends Component{
    constructor(props) {
        super(props);
        const {productId, productName} = this.props.params || {};
        this.state={
            details: undefined,
            productId,
            productName,
            ongoing: undefined,
            upcoming: [],
            completed: [],
            upcomingPage: 1,
            completedPage: 1,
            isLoading: true,
            selected: undefined,
            isChangeBook: false,
            isChanging: false,
        }
    }
    componentDidMount() {
        this.getDetails();
        socket.on('success',this.handleSuccess);
        socket.on('failure',this.handleFailure);
    }
    componentWillUnmount() {
        socket.off('success');
        socket.off('failure');
    }
    getDetails = () =>{
        this.setState({isLoading: true});
        console.log('calling get Details');
        socket.emit('UserProfile',{mobile: this.props.mobile});
        socket.emit('PlanDetails',{mobile: this.props.mobile,productId: this.state.productId});
    }
    handleSuccess = (data) =>{
        console.log(data);
        switch(data?.type){
            case 'UserProfile':
                this.setState({details:data?.details});
                break;
            case 'PlanDetails':
                const {upcoming,completed,ongoing,status} = data;
                this.setState({upcoming,completed,ongoing,status,isLoading: false});
                break;
            case 'ChangeBook':
                this.setState({isChanging: false});
                this.getDetails();
                this.hideChangeBook();
                break;
        }
    }
    handleFailure = (data) =>{
        switch(data?.type){
            case 'PlanDetails':
                this.setState({ongoing: undefined,completed: [],upcoming: [],isLoading: false});
                break;
        }
    }
    changeType = (type) =>{
        this.setState({type,isLoading: true,upcomingPage: 1, completedPage: 1});
        socket.emit('PlanDetails',{mobile: this.props.mobile,type});
    }
    handleSelected = (selected) => this.setState({selected});
    showChangeBook = () => this.setState({selected: this.state?.upcoming?.[0]?.id,isChangeBook: true});
    hideChangeBook = () => this.setState({selected: undefined,isChangeBook: false});
    handleChangeBook = () =>{
        const {type,selected,productId} = this.state;
        this.setState({isChanging: true});
        socket.emit('ChangeBook',{productId,selected,mobile: this.props.mobile});
    }

    render() {
        const {productName,details,upcoming,completed,ongoing,isLoading,upcomingPage,completedPage,status,selected,isChangeBook,isChanging} = this.state;
        return <div>
            <CustomHeader showBackPress={true} />
            <div style={{marginTop: 60, width: '100%'}}>
            {isLoading ? <Group position={'center'}><Loader color={'#075E54'}/></Group> : <div style={{marginTop: 60, width: '100%'}}>
                <Text weight={'bold'} color={Colors.Primary} size={'xl'}>{productName}</Text>

                {status === 1 ? <>
                    {ongoing && <>
                        <Text weight={'bold'} my={5}>Ongoing Books</Text>
                        <BookView details={ongoing} />
                    </>}
                    <Tabs defaultValue="upcoming">
                        <Tabs.List>
                            <Tabs.Tab value="upcoming"><Text weight={'bold'}>Upcoming</Text></Tabs.Tab>
                            <Tabs.Tab value="completed"><Text weight={'bold'}>Completed</Text></Tabs.Tab>
                        </Tabs.List>
                        <Tabs.Panel value="upcoming" pt="xs">
                            {upcoming.length > 0 ?<>
                                <Modal
                                    title={<Text weight={'bold'}>Change Next Book</Text>}
                                    overflow="outside"
                                    opened={isChangeBook}
                                    onClose={this.hideChangeBook}
                                    size={'95%'}
                                    sx={{height: '90%'}}
                                >
                                    <Select
                                        data={upcoming.map(a => ({label: a?.title, value: a?.id}))}
                                        searchable={true}
                                        label={<Text weight={'bold'}>Select Book</Text>}
                                        value={selected}
                                        onChange={this.handleSelected}
                                    />
                                    <Group position={'center'} my={25}>
                                        <Button onClick={this.handleChangeBook} loading={isChanging}>Update Next Book</Button>
                                    </Group>

                                </Modal>
                                <Group mb={10} position={'apart'}>
                                    <Pagination siblings={1} size={'xs'} my={10} total={Math.ceil(upcoming.length/10)} page={upcomingPage} onChange={(page) => this.setState({upcomingPage: page})} />
                                    <Button variant={'outline'} size={'sm'} onClick={this.showChangeBook}> Change Next Book</Button>
                                </Group>
                                <Grid>
                                    {upcoming.slice((upcomingPage-1)  * 10,((upcomingPage -1)* 10)+10).map(a =>{
                                        return <Grid.Col span={12} lg={3} xl={3} md={4} my={1} py={3}>
                                            <BookView details={a} />
                                        </Grid.Col>
                                    })}
                                </Grid>
                            </>: <Text weight={'bold'} align={'center'}>No Upcoming Books</Text>}
                        </Tabs.Panel>
                        <Tabs.Panel value="completed" pt="xs">
                            {completed.length > 0 ?<>
                                <Pagination siblings={1} size={'xs'} my={10} total={Math.ceil(completed.length/10)} page={completedPage} onChange={(page) => this.setState({completedPage: page})} />
                                <Grid>
                                    {completed.slice((completedPage - 1)  * 10,((completedPage -1)* 10)+10).map(a =>{
                                        return <Grid.Col span={12} lg={3} xl={3} md={4} my={1} py={3}>
                                            <BookView details={a} />
                                        </Grid.Col>
                                    })}
                                </Grid>
                            </>:<Text weight={'bold'} align={'center'}>No Completed Books</Text>}
                        </Tabs.Panel>
                    </Tabs>
                </> : <Text> You're Plan is Paused.. Please Resume it.</Text>}
            </div>}
            </div>
            </div>
    }
}
export default function(props){
    const navigation = useNavigate();
    const {state} = useLocation();
    const user = getUserDetails();
    return <PlanDetails {...props} params={state} navigation={navigation} mobile={user?.mobile} user={user}  />
};
